// extracted by mini-css-extract-plugin
export var root = "BlogListHero-module--root--cabe3";
export var title = "BlogListHero-module--title--690c8";